import { FC } from 'react';
import ContractEdit from '../components/contract/ContractEdit';
import CommonPage from '../components/page/CommonPage';
import { PageTitle } from '../components/common/PageTitle';

const ContractEditPage : FC= () => {
    
    return (
        <CommonPage selectBtnIndex={1}>
            <PageTitle title="契約編集" />
            <ContractEdit />
        </CommonPage>
    );
}

export default ContractEditPage;